import { useLanguage } from '../context/LanguageContext'
const NAVY = '#002E53'
const GOLD = '#C5A059'
const FONT = "'Poppins', sans-serif"

const DXB_URL = 'https://dxbinteract.com'

const REPORT_KEYS = ['r1', 'r2', 'r3', 'r4', 'r5', 'r6']
const REPORT_ICONS = ['📊', '📅', '📈', '🗓️', '🏆', '🗺️']
const REPORT_HREFS = [
  'https://dxbinteract.com/dubai-property-market/daily-report',
  'https://dxbinteract.com/dubai-property-market/weekly-report',
  'https://dxbinteract.com/dubai-housing-market-february-2026',
  'https://dxbinteract.com/dubai-real-estate-market-report-2025-4',
  'https://dxbinteract.com/dubai-real-estate-yearly-report-2025',
  'https://dxbinteract.com/dubai-market-analysis/?mode=area',
]


function TransactionReportSection() {
  const { t } = useLanguage()
  const REPORTS = REPORT_KEYS.map((key, i) => ({
    icon: REPORT_ICONS[i],
    label: t(`txn.reports.${key}l`),
    desc: t(`txn.reports.${key}d`),
    href: REPORT_HREFS[i],
  }))
  return (
    <div id="transactions" style={{ background: '#fff', width: '100%', scrollMarginTop: '100px' }}>
      <style>{`
        .txn-card {
          background: #f8fafc;
          border: 1px solid rgba(0,46,83,0.08);
          border-radius: 14px;
          padding: 26px 22px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          transition: all 0.28s ease;
          cursor: pointer;
          text-decoration: none;
        }
        .txn-card:hover {
          background: #fff;
          border-color: ${GOLD}55;
          box-shadow: 0 8px 28px rgba(197,160,89,0.13);
          transform: translateY(-4px);
        }
        .txn-arrow {
          display: inline-block;
          transition: transform 0.2s ease;
          color: ${GOLD};
          font-size: 15px;
          font-weight: 700;
        }
        .txn-card:hover .txn-arrow { transform: translateX(5px); }
        @media (max-width: 900px) { .txn-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 520px)  { .txn-grid { grid-template-columns: 1fr !important; } }
      `}</style>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '72px 20px 72px', boxSizing: 'border-box' }}>

        {/* ── Header ─────────────────────────────── */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '44px', flexWrap: 'wrap', gap: '20px' }}>
          <div>
            <span style={{
              display: 'inline-block', background: `${GOLD}18`, color: GOLD,
              fontFamily: FONT, fontSize: '11px', fontWeight: 700, letterSpacing: '1.8px',
              padding: '5px 14px', borderRadius: '50px', textTransform: 'uppercase',
              border: `1px solid ${GOLD}35`, marginBottom: '10px',
            }}>
              { t('txn.badge') }
            </span>
            <h2 style={{
              fontFamily: FONT, fontSize: 'clamp(24px, 3vw, 38px)', fontWeight: 700,
              color: NAVY, margin: 0, letterSpacing: '-0.3px', lineHeight: 1.2,
            }}>
              { t('txn.heading') }
            </h2>
            <p style={{
              fontFamily: FONT, fontSize: '15px', color: '#6b7a8d',
              margin: '10px 0 0', lineHeight: 1.6, maxWidth: '480px',
            }}>
              { t('txn.desc') }
            </p>
          </div>

          {/* Live badge + CTA */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
              <span style={{
                width: '8px', height: '8px', borderRadius: '50%',
                background: '#22c55e',
                boxShadow: '0 0 0 3px rgba(34,197,94,0.2)',
                animation: 'txn-pulse 2s ease infinite',
                display: 'inline-block',
              }} />
              <span style={{ fontFamily: FONT, fontSize: '13px', color: '#22c55e', fontWeight: 600 }}>{ t('txn.live') }</span>
            </div>
            <a
              href={DXB_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                background: NAVY, color: '#fff',
                fontFamily: FONT, fontSize: '14px', fontWeight: 600,
                padding: '12px 24px', borderRadius: '10px',
                textDecoration: 'none', transition: 'background 0.2s, transform 0.15s',
                whiteSpace: 'nowrap',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#001a33'; e.currentTarget.style.transform = 'translateY(-2px)' }}
              onMouseLeave={e => { e.currentTarget.style.background = NAVY; e.currentTarget.style.transform = 'translateY(0)' }}
            >
              { t('txn.openPlatform') }
            </a>
          </div>
        </div>

        {/* ── Report Cards ────────────────────────── */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '18px' }} className="txn-grid">
          {REPORTS.map((report, i) => (
            <a
              key={i}
              href={report.href}
              target="_blank"
              rel="noopener noreferrer"
              className="txn-card"
            >
              <div style={{ fontSize: '26px' }}>{report.icon}</div>
              <div style={{ fontFamily: FONT, fontSize: '15px', fontWeight: 700, color: NAVY }}>
                {report.label}
              </div>
              <div style={{ fontFamily: FONT, fontSize: '13px', color: '#6b7a8d', lineHeight: 1.6, flex: 1 }}>
                {report.desc}
              </div>
              <div style={{ fontFamily: FONT, fontSize: '13px', fontWeight: 600 }}>
                <span className="txn-arrow">{ t('txn.viewReport') }</span>
              </div>
            </a>
          ))}
        </div>

        {/* ── Bottom strip ────────────────────────── */}
        <div style={{
          marginTop: '32px',
          background: `linear-gradient(135deg, ${NAVY} 0%, #001a33 100%)`,
          borderRadius: '16px',
          padding: '28px 32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '16px',
        }}>
          <div>
            <div style={{ fontFamily: FONT, fontSize: '16px', fontWeight: 700, color: '#fff', marginBottom: '4px' }}>
              { t('txn.ctaHeading') }
            </div>
            <div style={{ fontFamily: FONT, fontSize: '13px', color: 'rgba(255,255,255,0.55)' }}>
              { t('txn.ctaDesc') }
            </div>
          </div>
          <a
            href="/contact"
            style={{
              display: 'inline-block', background: GOLD, color: '#fff',
              fontFamily: FONT, fontSize: '14px', fontWeight: 700,
              padding: '12px 26px', borderRadius: '10px',
              textDecoration: 'none', transition: 'background 0.2s, transform 0.15s',
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#d4af6a'; e.currentTarget.style.transform = 'translateY(-2px)' }}
            onMouseLeave={e => { e.currentTarget.style.background = GOLD; e.currentTarget.style.transform = 'translateY(0)' }}
          >
            { t('txn.ctaBtn') }
          </a>
        </div>
      </div>

      <style>{`
        @keyframes txn-pulse {
          0%   { box-shadow: 0 0 0 0 rgba(34,197,94,0.35); }
          70%  { box-shadow: 0 0 0 7px rgba(34,197,94,0); }
          100% { box-shadow: 0 0 0 0 rgba(34,197,94,0); }
        }
      `}</style>
    </div>
  )
}

export default TransactionReportSection
